import { render, staticRenderFns } from "./ExamQ.vue?vue&type=template&id=efeb52d0&scoped=true&"
import script from "./ExamQ.vue?vue&type=script&lang=js&"
export * from "./ExamQ.vue?vue&type=script&lang=js&"
import style0 from "./ExamQ.vue?vue&type=style&index=0&id=efeb52d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efeb52d0",
  null
  
)

export default component.exports